import {
  MANAGER_ACCESS_LEVELS,
  PLATFORM_ROLES,
  formatEnumLabel,
  normalizeManagerAccessLevel as normalizeManagerAccessLevelValue,
  normalizePlatformRole,
} from './enums';

export const ROLES = PLATFORM_ROLES;
export { MANAGER_ACCESS_LEVELS };

export const normalizeRole = (role) => {
  return normalizePlatformRole(role) || null;
};

export const normalizeManagerAccessLevel = (value) => {
  return normalizeManagerAccessLevelValue(value) || null;
};

export const PARKTEK_INTERNAL_ROLES = Object.freeze([
  ROLES.SUPER_ADMIN,
  ROLES.DEVELOPER,
  ROLES.ACCOUNT_MANAGER,
]);

export const isParktekInternalRole = (role) => {
  const normalizedRole = normalizeRole(role);
  return PARKTEK_INTERNAL_ROLES.includes(normalizedRole);
};

export const canSwitchSocietyContext = (role) => {
  const normalizedRole = normalizeRole(role);
  return (
    normalizedRole === ROLES.SUPER_ADMIN ||
    normalizedRole === ROLES.DEVELOPER ||
    normalizedRole === ROLES.ACCOUNT_MANAGER
  );
};

export const THIRD_PARTY_SECTION_ROLES = Object.freeze([
  ROLES.SUPER_ADMIN,
  ROLES.DEVELOPER,
  ROLES.ACCOUNT_MANAGER,
  ROLES.SOCIETY_ADMIN,
  ROLES.SOCIETY_MANAGER,
]);

export const canAccessThirdPartySection = (role) => {
  const normalizedRole = normalizeRole(role);
  return THIRD_PARTY_SECTION_ROLES.includes(normalizedRole);
};

export const USER_BULK_IMPORT_ROLES = Object.freeze([ROLES.SUPER_ADMIN, ROLES.DEVELOPER]);

export const canUseUserBulkImport = (role) => {
  const normalizedRole = normalizeRole(role);
  return USER_BULK_IMPORT_ROLES.includes(normalizedRole);
};

export const formatRoleLabel = (role) => {
  const normalizedRole = normalizeRole(role);
  return normalizedRole ? formatEnumLabel(normalizedRole) : '-';
};
